import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { CampaignType, ObjectRelationshipTriggerType, ObjectTriggerType, TriggerCategory } from './campaign';

/**
 * Taken from "services" for mapping
 * const (
 *    CampaignType_Customer             CampaignType = 0
 *    CampaignType_Event                CampaignType = 1
 *    CampaignType_TriggeredBroadcast   CampaignType = 2
 *    CampaignType_None                 CampaignType = 3
 *    CampaignType_Date                 CampaignType = 4
 *    CampaignType_TransactionalMessage CampaignType = 5
 *    CampaignType_FormEvent            CampaignType = 6
 *    CampaignType_WebhookTriggered     CampaignType = 7
 *    CampaignType_Relationship         CampaignType = 8
 *    CampaignType_Object               CampaignType = 9
 * )
 */
const CampaignTypeNumberToTypeText = [
  CampaignType.Behavioral,
  CampaignType.Transactional,
  CampaignType.APITriggered,
  CampaignType.None,
  CampaignType.Date,
  null,
  CampaignType.Form,
  CampaignType.Webhook,
  CampaignType.ObjectRelationship,
  CampaignType.Object,
];

export default class RecentTriggerModel extends Model {
  @attr('number') campaignType!: number;
  @attr('number') objectTypeId!: number | null;
  @attr('number') triggerType!: ObjectTriggerType | ObjectRelationshipTriggerType | null;

  get type() {
    return CampaignTypeNumberToTypeText[this.campaignType];
  }

  get isValidForCampaignTrigger() {
    switch (this.type) {
      case CampaignType.Transactional:
      case CampaignType.Behavioral:
      case CampaignType.Date:
      case CampaignType.Form:
      case CampaignType.Webhook:
      case CampaignType.Object:
      case CampaignType.ObjectRelationship: {
        return true;
      }
      default: {
        return false;
      }
    }
  }

  get campaignTriggerCategory() {
    switch (this.type) {
      case CampaignType.Date: {
        return TriggerCategory.dates;
      }
      case CampaignType.Webhook: {
        return TriggerCategory.webhooks;
      }
      case CampaignType.Object:
      case CampaignType.ObjectRelationship: {
        return `object_type_${this.objectTypeId}`;
      }
      case CampaignType.Behavioral:
      case CampaignType.Transactional:
      case CampaignType.Form:
      default: {
        return TriggerCategory.people;
      }
    }
  }
}

/**
 * Used for tests to generate correct type int respponse from campaign type
 */
export function campaignTypeToInt(type: CampaignType) {
  let index = CampaignTypeNumberToTypeText.indexOf(type);
  if (type != null && index >= 0) {
    return index;
  }
  return null;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'recent-trigger': RecentTriggerModel;
  }
}
